import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, withProps, renderNothing } from 'recompose';

const LocationSelector = ({
  value,
  onChange,
  options,
}) => (
  <select
    name="selectedLocation"
    className="c-select"
    data-automation-id="location-selector"
    value={value}
    onChange={onChange}
  >
    {options.map(option => (
      <option value={option.value} key={option.value}>{option.label}</option>
    ))}
  </select>
);

LocationSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

const LocationSelectorContainer = compose(
  withProps(ownProps => ({
    options: ownProps.locationSelectorOptions,
    value: ownProps.selectedLocation,
    onChange: ownProps.onSelectedLocationChange,
  })),
  branch(
    ({ options }) => !options || options.length === 0,
    renderNothing,
  )
)(LocationSelector);

export default LocationSelectorContainer;
